export type ReportingType = {
  key: number;
  value: number;
  text: string;
};

export type ReportMetric = {
  key: number;
  value: number;
  text: string;
  selected: boolean;
};

export type Report = {
  name: string;
  id: string;
  createdBy: string;
  modifiedBy: string;
  createdAt: string;
  modifiedAt: string;
  isReportingTypeModalOpen: boolean;
  componentType: string;
  reportingTypeIds: Array<number>;
  reportingTypeModalIdst: Array<number>;
  reportingTypeTable: Record<string, any>;
  reportsList: Array<Report>;
  rangeStart: any; // TBD with date implementation
  rangeEnd: any; // TBD with date implementation
  reportingTypesList: Array<ReportingType>;
  metricsList: Array<ReportMetric>;
  reportDataAsCsv: string;
};

export type ReportsHighchartState = {
  type?: string;
  selectChartType: Array<any>;
  chartType: string;
  config: Record<string, any>;
  reportingTypeModalIds: Array<number>;
  reportingTypeTable: Record<string, any>;
  metricsList: Array<ReportMetric>;
};
export type DeleteReportModal = {
  deleteReportModalIsOpen: boolean;
  deleteReportData: {
    reportName: string;
    reportId: number;
  };
};

export enum ActiveMenuItemEnum {
  dateTimeTable = 1,
  componentTable = 2,
}
